export default "__VITE_ASSET__b03404d3__"